export default __webpack_public_path__ + "media/images/service-image-601a700f4b5075bfc2f9bd5260f7497e.png";